// extracted by mini-css-extract-plugin
export default {"page":"Recommendations_page__tqwJl","bottomBar":"Recommendations_bottomBar__SkE7e","secondary":"Recommendations_secondary__QwbWx","primary":"Recommendations_primary__KCwyW"};